import React from 'react';
import { Box, PaletteColor, useTheme } from '@mui/material';
import { useThemeContrastColor, usePaletteTint } from '@europrocurement/flexy-components/hooks';

export type CountBadgeProps = {
    count: number | string;
    color?: 'primary' | 'secondary' | 'info' | 'warning' | 'error';
    bgVariant?: 'main' | 'dark' | 'light';
    contrastText?: boolean;
    textColorOverride?: PaletteColor;
};

export const CountBadge: React.FunctionComponent<CountBadgeProps> = function ({
    count,
    color = 'primary',
    bgVariant = 'light',
    contrastText = true,
    textColorOverride = undefined,
}) {
    const { palette } = useTheme();
    const contrastColor = useThemeContrastColor();
    const tint = usePaletteTint();

    const backgroundColor = tint(palette[color][bgVariant]);

    // Texte sur le badge : couleur de palette qui contraste avec le background calculé
    let textColor: string = 'inherit';
    if (contrastText) {
        textColor = contrastColor(backgroundColor, 4.5, 'text');
    }
    if (textColorOverride) {
        textColor = textColorOverride.main;
    }

    return (
        <Box
            data-testid="CountBadge-test-id"
            color={textColor}
            sx={{
                fontSize: '12px',
                fontWeight: '700',
                lineHeight: '14.4px',
                padding: '2px 5px',
                borderRadius: '16px',
                backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {count}
        </Box>
    );
};
